import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

const Home = () => {
    return (
        <> 
            <div className="hero-container">
                <div className="hero-content">
                    <span className="hero-tagline">Corporate Excellence</span>
                    <h1 className="hero-title">Structural Integrity for Modern Business.</h1>
                    <p className="hero-description">
                        The Pillar provides the multi-page architecture your brand needs to scale. 
                        From detailed service breakdowns to in-depth corporate profiles, 
                        we build the digital foundation that supports your long-term growth.
                    </p>
                    <div className="hero-btns">
                        <Link to="/services" className="btn-main">Our Services</Link>
                        <Link to="/about" className="btn-outline">About The Pillar</Link>
                    </div>
                </div>
            </div>

            <section className="capabilities-section">
                <div className="capabilities-header">
                    <h2>Core Capabilities</h2>
                </div>

                <div className="capabilities-grid">
                    <div className="capability-card">
                        <div className="capability-icon">🏛️</div>
                        <h3>Corporate Identity</h3>
                        <p>We build professional digital environments that reflect the strength and history of your brand.</p>
                    </div>

                    <div className="capability-card">
                        <div className="capability-icon">📈</div>
                        <h3>Strategic Growth</h3>
                        <p>Multi-page architectures designed to host complex service offerings and detailed case studies.</p>
                    </div>

                    <div className="capability-card">
                        <div className="capability-icon">⚖️</div>
                        <h3>Executive Trust</h3>
                        <p>High-contrast, readable layouts that command respect and establish authority in your industry.</p>
                    </div>
                </div>
            </section>
        </>
    );
};

export default Home;